import * as actionTypes from '../actions/actionTypes';

export default function headerdetailsReducer(state = {}, action) {
  switch(action.type){
    case actionTypes.SET_HEADER_DATA: {
      let  {lastLogin, logOff }= action;
      return {lastLogin, logOff};
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/layouts/reducers/headerdetailsReducer.js